import { useEffect, useState } from "react";

import doc1 from "../assets/image.jpeg";
import doc2 from "../assets/image1.jpeg";
import doc3 from "../assets/image2.jpeg";

const DOCS = [
  { src: doc1, title: "Document 1" },
  { src: doc2, title: "Document 2" },
  { src: doc3, title: "Document 3" },
];

export default function Documents() {
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (active === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") setActive(null);
      if (e.key === "ArrowRight") setActive((i) => (i + 1) % DOCS.length);
      if (e.key === "ArrowLeft") setActive((i) => (i - 1 + DOCS.length) % DOCS.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active]);

  return (
    <>
      <style>{`
        .docs-page{ background:#fff; color:#1a1a1a; font-family:'Plus Jakarta Sans', sans-serif; padding:32px 16px 120px; }
        .docs-inner{ max-width:1100px; margin:0 auto; }
        .docs-title{ font-family:'Poppins', sans-serif; font-size:28px; font-weight:800; text-align:center; margin:0 0 6px; }
        .docs-sub{ text-align:center; color:#666; margin:0 0 28px; font-size:14px; }
        .docs-grid{ display:grid; grid-template-columns:repeat(auto-fill, minmax(260px, 1fr)); gap:20px; }
        .docs-card{ background:#fff; border:1px solid #eee; border-radius:14px; overflow:hidden; cursor:pointer;
          box-shadow:0 4px 14px rgba(0,0,0,.06); transition:transform .2s, box-shadow .2s; padding:0; text-align:left; }
        .docs-card:hover{ transform:translateY(-4px); box-shadow:0 10px 24px rgba(0,0,0,.12); }
        .docs-thumb{ width:100%; height:220px; object-fit:contain; background:#f6f6f6; display:block; }
        .docs-cap{ padding:12px 14px; font-weight:700; font-size:14px; }
        .docs-lb{ position:fixed; inset:0; background:rgba(0,0,0,.88); z-index:9999; display:flex;
          align-items:center; justify-content:center; padding:16px; }
        .docs-lb img{ max-width:100%; max-height:88vh; object-fit:contain; border-radius:8px; }
        .docs-lb-btn{ position:absolute; background:rgba(255,255,255,.15); color:#fff; border:none; border-radius:50%;
          width:44px; height:44px; font-size:22px; cursor:pointer; }
        .docs-lb-btn:hover{ background:rgba(255,255,255,.3); }
        .docs-close{ top:16px; right:16px; }
        .docs-prev{ left:12px; top:50%; transform:translateY(-50%); }
        .docs-next{ right:12px; top:50%; transform:translateY(-50%); }
      `}</style>

      <div className="docs-page">
        <div className="docs-inner">
          <h1 className="docs-title">Documents</h1>
          <p className="docs-sub">Click a document to view it in full size</p>
          <div className="docs-grid">
            {DOCS.map((d, i) => (
              <button key={d.title} type="button" className="docs-card" onClick={() => setActive(i)}>
                <img src={d.src} alt={d.title} className="docs-thumb" />
                <div className="docs-cap">{d.title}</div>
              </button>
            ))}
          </div>
        </div>
      </div>

      {active !== null && (
        <div className="docs-lb" onClick={() => setActive(null)}>
          <img src={DOCS[active].src} alt={DOCS[active].title} onClick={(e) => e.stopPropagation()} />
          <button className="docs-lb-btn docs-close" aria-label="Close" onClick={() => setActive(null)}>✕</button>
          <button className="docs-lb-btn docs-prev" aria-label="Previous"
            onClick={(e) => { e.stopPropagation(); setActive((active - 1 + DOCS.length) % DOCS.length); }}>‹</button>
          <button className="docs-lb-btn docs-next" aria-label="Next"
            onClick={(e) => { e.stopPropagation(); setActive((active + 1) % DOCS.length); }}>›</button>
        </div>
      )}
    </>
  );
}
